import TruckLineIcon from "remixicon-react/TruckLineIcon";

import { InfoContainer, Text } from "$components";
import { useStyles } from "../styles/DeliveryPicker.styles";
import DateIntervention from "../components/DeliveryPicker/DateIntervention";
import DateDispo from "../components/DeliveryPicker/DateDispo";
import DispoType from "../components/DeliveryPicker/DispoType";
import ContactForm from "../components/DeliveryPicker/ContactForm";
import DeliveryPickerModals from "../components/DeliveryPicker/Modals";
import AdditionalInfo from "../components/DeliveryPicker/AdditionalInfo";
import { DeliveryEDBProvider } from "$containers/EDB/ProfileEDB/context/DeliveryContext";

function DeliveryPicker({ edbCompanyId }: { edbCompanyId: string | null }) {
  const classes = useStyles();
  return (
    <DeliveryEDBProvider edbCompanyId={edbCompanyId}>
      <div>
        <InfoContainer
          leftHeader={
            <>
              <TruckLineIcon />
              <Text type="h3" className={classes.title}>
                Préparation et livraison
              </Text>
            </>
          }
        >
          <ContactForm />
          <DateIntervention />
          <DateDispo />
          <DispoType />
          <AdditionalInfo />
        </InfoContainer>

        <DeliveryPickerModals />
      </div>
    </DeliveryEDBProvider>
  );
}

export default DeliveryPicker;
